import { ConfigurationRepository } from '../../../domain/repositories/configuration.repository';
import { GetCanalUseCase } from '../../../domain/usecases/configuration/get-canal.usecase';
import { GetCityUseCase } from '../../../domain/usecases/configuration/get-city-usecase';
import { GetCountryUseCase } from '../../../domain/usecases/configuration/get-country-usecase';
import { GetStateProspectUseCase } from '../../../domain/usecases/configuration/get-state-prospect.usecase';
import { GetTypeBloodUseCase } from '../../../domain/usecases/configuration/get-tipe-blood-usecase';
import { GetTypeDocumentUseCase } from '../../../domain/usecases/configuration/get-type-document.usecase';
import { GetTypeCanalUseCase } from '../../../domain/usecases/configuration/type-canal/get-type-canal.usecase';
import { InsertTypeCanalUseCase } from '../../../domain/usecases/configuration/type-canal/insert-type-canal.usecase';
import { DeleteTypeCanalUseCase } from '../../../domain/usecases/configuration/type-canal/delete-type-canal.usecase';
import { UpdateTypeCanalUseCase } from '../../../domain/usecases/configuration/type-canal/update-type-canal.usecase';
import { GetCampusCompanyUseCase } from '../../../domain/usecases/configuration/company/get-campus-company-usecase';
import { GetConsultancyCompanyUseCase } from '../../../domain/usecases/configuration/company/get-consultancy-company.usecase';
import { GetTypeServiceCompanyUseCase } from '../../../domain/usecases/configuration/company/get-type-services-company-usecase';
import { GetServiceCompanyUseCase } from '../../../domain/usecases/configuration/company/get-services-company-usecase';
import { GetCollaboratorCompanyUseCase } from '../../../domain/usecases/configuration/company/get-collaborator-company-usecase';
import { GetProfesionalByCompanyidUseCase } from '../../../domain/usecases/configuration/company/get-profesional-by-companyid.usecase';
import { GetStateCivilUseCase } from '../../../domain/usecases/configuration/get-state-civil.usecase';
import { GetEPSUseCase } from '../../../domain/usecases/configuration/get-eps.usecase';
import { GetGenderUseCase } from '../../../domain/usecases/configuration/get-gender.usecase';
import { GetRelationShipUseCase } from '../../../domain/usecases/configuration/get-relation-ship.usecase';
import { GetAgreementUseCase } from '../../../domain/usecases/configuration/get-agreement.usecase';
import { GetPrepaidMedicineUseCase } from '../../../domain/usecases/configuration/get-prepaid-medicine.usecase';
import { GetDiagnosticUseCase } from '../../../domain/usecases/configuration/get-diagnostic.usecase';
import { GetRevisionUseCase } from '../../../domain/usecases/configuration/get-revision-usecase';
import { GetDepartamentUseCase } from '../../../domain/usecases/configuration/get-departament-usecase';
import { GetStateProspectFollowupUseCase } from '../../../domain/usecases/configuration/get-state-prospect-followup.usecase';
import { GetLocationUseCase } from '../../../domain/usecases/configuration/get-location-usecase';
import { GetTypeInvoiceUseCase } from '../../../domain/usecases/configuration/get-type-invoice.usecase';
import { GetInvoiceUseCase } from '../../../domain/usecases/configuration/get-invoice.usecase';
import { GetProfessionalUseCase } from '../../../domain/usecases/configuration/get-professional.usecase';
import { InsertInvoiceUseCase } from '../../../domain/usecases/configuration/insert-invoice-usecase';
import { GetPendingInvoiceReportUseCase } from '../../../domain/usecases/configuration/get-pending-invoice-report.usecase';
import { GetConsentUseCase } from '../../../domain/usecases/configuration/consent/get-consent.usecase';
import { InsertConsentUseCase } from '../../../domain/usecases/configuration/consent/insert-consent.usecase';
import { DeleteConsentUseCase } from '../../../domain/usecases/configuration/consent/delete-consent.usecase';
import { UpdateConsentUseCase } from '../../../domain/usecases/configuration/consent/update-consent.usecase';
import { GetTypeOrganizationUseCase } from '../../../domain/usecases/configuration/get-type-organization-usecase';
import { GetConveniosByEmpresaUseCase } from '../../../domain/usecases/configuration/convenio/get-convenio.usecase';
import { GetMetodoPagoSaludUseCase } from '../../../domain/usecases/configuration/get-metodo-pago-salud.usecase';
import { GetMetodoPagoFinancieroUseCase } from '../../../domain/usecases/configuration/get-metodo-pago-financiero.usecase';
import { GetTipoPlanSaludUseCase } from '../../../domain/usecases/configuration/get-tipo-plan-salud.usecase';
import { InsertConvenioUseCase } from '../../../domain/usecases/configuration/convenio/insert-convenio.usecase';
import { GetThirdCompanyUseCase } from '../../../domain/usecases/configuration/company/get-third-company.usecase';
import { GetThirdCompanyAllUseCase } from '../../../domain/usecases/configuration/company/get-third-company-all.usecase';
import { InsertThirdCompanyUseCase } from '../../../domain/usecases/configuration/company/insert-third-company.usecase';
import { DeleteThirdCompanyUseCase } from '../../../domain/usecases/configuration/company/delete-third-company.usecase';
import { UpdateThirdCompanyUseCase } from '../../../domain/usecases/configuration/company/update-third-company.usecase';
import { GetThirdCompanyByIdUseCase } from '../../../domain/usecases/configuration/company/get-third-company-by-id.usecase';
import { UpdateConvenioUseCase } from '../../../domain/usecases/configuration/convenio/update-convenio.usecase';
import { DeleteConvenioUseCase } from '../../../domain/usecases/configuration/convenio/delete-convenio.usecse';
import { GetFiscalResponsibilityUseCase } from '../../../domain/usecases/configuration/get-fiscal-responsibility.usecase';
import { GetInvoiceRIPSConfigurationByCompanyUseCase } from '../../../domain/usecases/configuration/invoice-rips-configuration/get-invoice-rips-configuration-by-empresa.usecase';
import { GetInvoiceRIPSByCompanyIdAdminUseCase } from '../../../domain/usecases/configuration/invoice-rips-configuration/get-invoice-rips-by-company-id-admin.usecase';
import { InsertInvoiceRIPSConfigurationUseCase } from '../../../domain/usecases/configuration/invoice-rips-configuration/insert-invoice-rips-configuration.usecase';
import { InsertInvoiceRIPSByCompanyIdAdminUseCase } from '../../../domain/usecases/configuration/invoice-rips-configuration/insert-invoice-rips-by-company-id-admin.usecase';
import { UpdateInvoiceRIPSConfigurationUseCase } from '../../../domain/usecases/configuration/invoice-rips-configuration/update-invoice-rips-configuration.usecase';
import { UpdateInvoiceRIPSByCompanyIdAdminUseCase } from '../../../domain/usecases/configuration/invoice-rips-configuration/update-invoice-rips-by-company-id-admin.usecase';
import { GetOrganizationTypeInvoiceRIPSUseCase } from '../../../domain/usecases/configuration/get-organization-type-invoice-rips.usecase';
import { GetEnablingsCodeUseCase } from '../../../domain/usecases/consult/get-enablings-code.usecase';
import { GetBusinessAllUseCase } from '../../../domain/usecases/configuration/company/get-business-all.usecase';
import { GetBusinessByIdUseCase } from '../../../domain/usecases/configuration/company/get-business-by-id.usecase';
import { InsertBusinessUseCase } from '../../../domain/usecases/configuration/company/insert-business.usecase';
import { UpdateBusinessUseCase } from '../../../domain/usecases/configuration/company/update-business.usecase';
import { UpdateLogoBusinessUseCase } from '../../../domain/usecases/configuration/company/update-logo-business.usecase';
import { GetTypeBusinessUseCase } from '../../../domain/usecases/configuration/company/get-type-business.usecase';
import { GetUsersUseCase } from '../../../domain/usecases/configuration/get-users.usecase';
import { GetChargeUseCase } from '../../../domain/usecases/configuration/get-charge.usecase';
import { GetTypeServiceUseCase } from '../../../domain/usecases/configuration/get-type-service.usecase';
import { GetServiceUseCase } from '../../../domain/usecases/configuration/get-service.usecase';
import { GetServiceByCompanyidUseCase } from '../../../domain/usecases/configuration/get-service-by-companyid.usecase';
import { InsertDemoBusinessUseCase } from '../../../domain/usecases/configuration/company/post-demo-business.usecase';
import { GetHeadquartersByIdCompanyUseCase } from '../../../domain/usecases/configuration/company/get-headquarters-by-id-company.usecase';
import { GetHeadquartersByCompanyidUseCase } from '../../../domain/usecases/configuration/company/get-headquarters-by-companyid.usecase';
import { GetHeadquartersAllByCompanyIdAdminUseCase } from '../../../domain/usecases/configuration/company/get-headquarters-all-by-company-id-admin.usecase';
import { InsertHeadquartersUseCase } from '../../../domain/usecases/configuration/company/insert-headquarters.usecase';
import { InsertHeadquartersAdminUseCase } from '../../../domain/usecases/configuration/company/insert-headquarters-admin.usecase';
import { UpdateHeadquartersUseCase } from '../../../domain/usecases/configuration/company/update-headquarters.usecase';
import { UpdateHeadquartersAdminUseCase } from '../../../domain/usecases/configuration/company/update-headquarters-admin.usecase';
import { DeleteHeadquartersUseCase } from '../../../domain/usecases/configuration/company/delete-headquarters.usecase';
import { InsertOfficesUseCase } from '../../../domain/usecases/configuration/company/insert-officess.usecase';
import { InsertOfficesIdAdminUseCase } from '../../../domain/usecases/configuration/company/insert-offices-id-admin.usecase';
import { UpdateOfficesUseCase } from '../../../domain/usecases/configuration/company/update-office.usecase';
import { UpdateOfficesIdAdminUseCase } from '../../../domain/usecases/configuration/company/update-offices-id-admin.usecase';
import { DeleteOfficesUseCase } from '../../../domain/usecases/configuration/company/delete-office.usecase';
import { DeleteOfficesIdAdminUseCase } from '../../../domain/usecases/configuration/company/delete-offices-id-admin.usecase';
import { GetOfficeByHeadquartersUseCase } from '../../../domain/usecases/configuration/company/get-office-by-id-headquarters.usecase';
import { GetOfficeByHeadquartersIdAdminUseCase } from '../../../domain/usecases/configuration/company/get-office-by-headquarters-id-admin.usecase';
import { GetCollaboratorCompanyAllUseCase } from '../../../domain/usecases/configuration/company/get-collaborator-company-all-usecase';
import { GetCollaboratorAllAdminUseCase } from '../../../domain/usecases/configuration/company/get-collaborator-all-admin.usecase';
import { GetStateCollaboratorUseCase } from '../../../domain/usecases/configuration/company/get-state-collaborator.usecase';
import { InsertCollaboratorUseCase } from '../../../domain/usecases/configuration/company/insert-collaborator.usecase';
import { InsertCollaboratorAllAdminUseCase } from '../../../domain/usecases/configuration/company/insert-collaborator-all-admin.usecase';
import { UpdateCollaboratorUseCase } from '../../../domain/usecases/configuration/company/update-collaborator.usecase';
import { UpdateCollaboratorAllAdminUseCase } from '../../../domain/usecases/configuration/company/update-collaborator-all-admin.usecase';
import { GetCollaboratorPositionUseCase } from '../../../domain/usecases/configuration/company/get-collaboratorposition.usecase';
import { InsertCollaboratorPositionUseCase } from '../../../domain/usecases/configuration/company/insert-collaboratorposition.usecase';
import { UpdateCollaboratorPositionUseCase } from '../../../domain/usecases/configuration/company/update-collaboratorposition.usecase';
import { GetPlanBusinessUseCase } from '../../../domain/usecases/configuration/company/get-plan-business.usecase';
import { GetPlanBussinesIdAdminUseCase } from '../../../domain/usecases/configuration/company/get-plan-bussines-id-admin.usecase';
import { GetDocumentsSystemUseCase } from '../../../domain/usecases/configuration/get-documents-system.usecase';
import { CreateDocumentSystemUseCase } from '../../../domain/usecases/configuration/create-document-system.usecase';
import { UpdateDocumentsSystemUseCase } from '../../../domain/usecases/configuration/update-documents-system.usecase';
import { GetFileDocumentsSystemUseCase } from '../../../domain/usecases/configuration/get-file-documents-system.usecase';
import { CreateFileDocumentsSystemUseCase } from '../../../domain/usecases/configuration/create-file-documents-system.usecase';
import { UpdateFileDocumentsSystemUseCase } from '../../../domain/usecases/configuration/update-file-documents-system.usecase';
import { GetChannelSendUseCase } from '../../../domain/usecases/configuration/get-channel-send.usecase';
import { CreateChannelSendUseCase } from '../../../domain/usecases/configuration/create-channel-send.usecase';
import { UpdateChannelSendUseCase } from '../../../domain/usecases/configuration/update-channel-send.usecase';
import { GetFileDocumentsSystemByIdUseCase } from '../../../domain/usecases/configuration/get-file-documents-system-by-id.usecase';
import { GetAllMenuUseCase }
from "../../../domain/usecases/configuration/get-all-menu.usecase";
import { InsertMenuUseCase }
from "../../../domain/usecases/configuration/insert-menu.usecase";
import { UpdateMenuUseCase }
from "../../../domain/usecases/configuration/update-menu.usecase";
import { GetAllPerfilUseCase }
from "../../../domain/usecases/configuration/get-all-perfil.usecase";
import { InsertPerfilUseCase }
from "../../../domain/usecases/configuration/insert-perfil.usecase";
import { UpdatePerfilUseCase }
from "../../../domain/usecases/configuration/update-perfil.usecase";
import { GetAllPerfilMenuUseCase }
from "../../../domain/usecases/configuration/get-all-perfil-menu.usecase";
import { InsertPerfilMenuUseCase } from '../../../domain/usecases/configuration/insert-perfil-menu.usecase';
import { DeletePerfilMenuUseCase } from '../../../domain/usecases/configuration/delete-perfil-menu.usecase';
import { GetAllPerfilMenuByIdUseCase }
from "../../../domain/usecases/configuration/get-all-perfil-menu-by-id.usecase";
import { GetBusinessByIdAdminUseCase } from '../../../domain/usecases/configuration/company/get-business-by-id-admin.usecase';
import { GetBusinessByPagedUseCase } from '../../../domain/usecases/configuration/company/get-business-by-paged.usecase';
import { InsertScheduleProfessionalUseCase } from '../../../domain/usecases/configuration/insert-schedule-professional.usecase';
import { UpdateScheduleProfessionalUseCase } from '../../../domain/usecases/configuration/update-schedule-professional.usecase';
import { GetScheduleProfessionalByIdConpanyUseCase } from '../../../domain/usecases/configuration/get-schedule-professional-by-id-conpany.usecase';

const insertScheduleProfessionalUseCaseFactory = (
  configurationRepo: ConfigurationRepository
) => new InsertScheduleProfessionalUseCase(configurationRepo);

export const InsertScheduleProfessionalUseCaseProvider = {
  provide: InsertScheduleProfessionalUseCase,
  useFactory: insertScheduleProfessionalUseCaseFactory,
  deps: [ConfigurationRepository],
};

const updateScheduleProfessionalUseCaseFactory = (
  configurationRepo: ConfigurationRepository
) => new UpdateScheduleProfessionalUseCase(configurationRepo);

export const UpdateScheduleProfessionalUseCaseProvider = {
  provide: UpdateScheduleProfessionalUseCase,
  useFactory: updateScheduleProfessionalUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getScheduleProfessionalByIdConpanyUseCaseFactory = (
  configurationRepo: ConfigurationRepository
) => new GetScheduleProfessionalByIdConpanyUseCase(configurationRepo);

export const GetScheduleProfessionalByIdConpanyUseCaseProvider = {
  provide: GetScheduleProfessionalByIdConpanyUseCase,
  useFactory: getScheduleProfessionalByIdConpanyUseCaseFactory,
  deps: [ConfigurationRepository],
};


const getCountryUseCaseFactory = (CountryRepo: ConfigurationRepository) =>
  new GetCountryUseCase(CountryRepo);
export const GetCountryUseCaseProvider = {
  provide: GetCountryUseCase,
  useFactory: getCountryUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getChargeUseCaseFactory = (ChargeRepo: ConfigurationRepository) =>
  new GetChargeUseCase(ChargeRepo);
export const GetChargeUseCaseProvider = {
  provide: GetChargeUseCase,
  useFactory: getChargeUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getTypeServiceUseCaseFactory = (
  TypeServiceRepo: ConfigurationRepository
) => new GetTypeServiceUseCase(TypeServiceRepo);
export const GetTypeServiceUseCaseProvider = {
  provide: GetTypeServiceUseCase,
  useFactory: getTypeServiceUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getEnablingsCodeUseCaseFactory = (
  EnablingsCodeRepo: ConfigurationRepository
) => new GetEnablingsCodeUseCase(EnablingsCodeRepo);
export const GetEnablingsCodeUseCaseProvider = {
  provide: GetEnablingsCodeUseCase,
  useFactory: getEnablingsCodeUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getFiscalResponsibilityUseCaseFactory = (
  FiscalResponsibilityRepo: ConfigurationRepository
) => new GetFiscalResponsibilityUseCase(FiscalResponsibilityRepo);
export const GetFiscalResponsibilityUseCaseProvider = {
  provide: GetFiscalResponsibilityUseCase,
  useFactory: getFiscalResponsibilityUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getMetodoPagoSaludFactory = (
  MetodoPagoSaludRepo: ConfigurationRepository
) => new GetMetodoPagoSaludUseCase(MetodoPagoSaludRepo);
export const GetMetodoPagoSaludUseCaseProvider = {
  provide: GetMetodoPagoSaludUseCase,
  useFactory: getMetodoPagoSaludFactory,
  deps: [ConfigurationRepository],
};

const getMetodoPagoFinancieroFactory = (
  MetodoPagoFinancieroRepo: ConfigurationRepository
) => new GetMetodoPagoFinancieroUseCase(MetodoPagoFinancieroRepo);
export const GetMetodoPagoFinancieroUseCaseProvider = {
  provide: GetMetodoPagoFinancieroUseCase,
  useFactory: getMetodoPagoFinancieroFactory,
  deps: [ConfigurationRepository],
};

const getTipoPlanSaludFactory = (TipoPlanSaludRepo: ConfigurationRepository) =>
  new GetTipoPlanSaludUseCase(TipoPlanSaludRepo);
export const GetTipoPlanSaludUseCaseProvider = {
  provide: GetTipoPlanSaludUseCase,
  useFactory: getTipoPlanSaludFactory,
  deps: [ConfigurationRepository],
};

const getTypeOrganizationFactory = (
  OrganizationRepo: ConfigurationRepository
) => new GetTypeOrganizationUseCase(OrganizationRepo);
export const GetTypeOrganizationUseCaseProvider = {
  provide: GetTypeOrganizationUseCase,
  useFactory: getTypeOrganizationFactory,
  deps: [ConfigurationRepository],
};

const getOrganizationTypeInvoiceRIPSFactory = (
  OrganizationRepo: ConfigurationRepository
) => new GetOrganizationTypeInvoiceRIPSUseCase(OrganizationRepo);
export const GetOrganizationTypeInvoiceRIPSUseCaseProvider = {
  provide: GetOrganizationTypeInvoiceRIPSUseCase,
  useFactory: getOrganizationTypeInvoiceRIPSFactory,
  deps: [ConfigurationRepository],
};

const getDepartamentUseCaseFactory = (DepartRepo: ConfigurationRepository) =>
  new GetDepartamentUseCase(DepartRepo);
export const GetDepartamentUseCaseProvider = {
  provide: GetDepartamentUseCase,
  useFactory: getDepartamentUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getCityUseCaseFactory = (CityRepo: ConfigurationRepository) =>
  new GetCityUseCase(CityRepo);
export const GetCityUseCaseProvider = {
  provide: GetCityUseCase,
  useFactory: getCityUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getLocationUseCaseFactory = (locaRepo: ConfigurationRepository) =>
  new GetLocationUseCase(locaRepo);
export const GetLocationUseCaseProvider = {
  provide: GetLocationUseCase,
  useFactory: getLocationUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getTypeDocumentUseCaseFactory = (TypeDocRepo: ConfigurationRepository) =>
  new GetTypeDocumentUseCase(TypeDocRepo);
export const GetTypeDocumentUseCaseProvider = {
  provide: GetTypeDocumentUseCase,
  useFactory: getTypeDocumentUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getCanalUseCaseFactory = (CanalRepo: ConfigurationRepository) =>
  new GetCanalUseCase(CanalRepo);
export const GetCanalUseCaseProvider = {
  provide: GetCanalUseCase,
  useFactory: getCanalUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getUsersFactory = (UsersRepo: ConfigurationRepository) =>
  new GetUsersUseCase(UsersRepo);
export const GetUsersUseCaseProvider = {
  provide: GetUsersUseCase,
  useFactory: getUsersFactory,
  deps: [ConfigurationRepository],
};

const getStateProspectUseCaseFactory = (StateRepo: ConfigurationRepository) =>
  new GetStateProspectUseCase(StateRepo);
export const GetStateProspectUseCaseProvider = {
  provide: GetStateProspectUseCase,
  useFactory: getStateProspectUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getStateProspectFollowupUseCaseFactory = (
  StateRepo: ConfigurationRepository
) => new GetStateProspectFollowupUseCase(StateRepo);
export const GetStateProspectFollowupUseCaseProvider = {
  provide: GetStateProspectFollowupUseCase,
  useFactory: getStateProspectFollowupUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getTypeBloodUseCaseFactory = (StateRepo: ConfigurationRepository) =>
  new GetTypeBloodUseCase(StateRepo);
export const GetTypeBloodUseCaseProvider = {
  provide: GetTypeBloodUseCase,
  useFactory: getTypeBloodUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getAgreementUseCaseFactory = (StateRepo: ConfigurationRepository) =>
  new GetAgreementUseCase(StateRepo);
export const GetAgreementUseCaseProvider = {
  provide: GetAgreementUseCase,
  useFactory: getAgreementUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getPrepaidMedicineUseCaseFactory = (StateRepo: ConfigurationRepository) =>
  new GetPrepaidMedicineUseCase(StateRepo);
export const GetPrepaidMedicineUseCaseProvider = {
  provide: GetPrepaidMedicineUseCase,
  useFactory: getPrepaidMedicineUseCaseFactory,
  deps: [ConfigurationRepository],
};

/**Type canal */
const getTypeCanalUseCaseFactory = (TypeCanalRepo: ConfigurationRepository) =>
  new GetTypeCanalUseCase(TypeCanalRepo);
export const GetTypeCanalUseCaseProvider = {
  provide: GetTypeCanalUseCase,
  useFactory: getTypeCanalUseCaseFactory,
  deps: [ConfigurationRepository],
};

const insertTypeCanalUseCaseFactory = (
  TypeCanalRepo: ConfigurationRepository
) => new InsertTypeCanalUseCase(TypeCanalRepo);
export const InsertTypeCanalUseCaseProvider = {
  provide: InsertTypeCanalUseCase,
  useFactory: insertTypeCanalUseCaseFactory,
  deps: [ConfigurationRepository],
};

const deleteTypeCanalUseCaseFactory = (
  TypeCanalRepo: ConfigurationRepository
) => new DeleteTypeCanalUseCase(TypeCanalRepo);
export const DeleteTypeCanalUseCaseProvider = {
  provide: DeleteTypeCanalUseCase,
  useFactory: deleteTypeCanalUseCaseFactory,
  deps: [ConfigurationRepository],
};

const updateTypeCanalUseCaseFactory = (
  TypeCanalRepo: ConfigurationRepository
) => new UpdateTypeCanalUseCase(TypeCanalRepo);
export const UpdateTypeCanalUseCaseProvider = {
  provide: UpdateTypeCanalUseCase,
  useFactory: updateTypeCanalUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getRevisionUseCaseFactory = (revisionRepo: ConfigurationRepository) =>
  new GetRevisionUseCase(revisionRepo);
export const GetRevisionUseCaseProvider = {
  provide: GetRevisionUseCase,
  useFactory: getRevisionUseCaseFactory,
  deps: [ConfigurationRepository],
};

/**Invoice RIPS Configuration */
const getInvoiceRIPSConfigurationByCompanyUseCaseFactory = (
  ConvenioRepo: ConfigurationRepository
) => new GetInvoiceRIPSConfigurationByCompanyUseCase(ConvenioRepo);
export const GetInvoiceRIPSConfigurationByCompanyUseCaseCaseProvider = {
  provide: GetInvoiceRIPSConfigurationByCompanyUseCase,
  useFactory: getInvoiceRIPSConfigurationByCompanyUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getInvoiceRIPSByCompanyIdAdminUseCaseFactory = (
  CompanyRepo: ConfigurationRepository
) => new GetInvoiceRIPSByCompanyIdAdminUseCase(CompanyRepo);
export const GetInvoiceRIPSByCompanyIdAdminUseCaseProvider = {
  provide: GetInvoiceRIPSByCompanyIdAdminUseCase,
  useFactory: getInvoiceRIPSByCompanyIdAdminUseCaseFactory,
  deps: [ConfigurationRepository],
};

const insertInvoiceRIPSByCompanyIdAdminUseCaseFactory = (
  CompanyRepo: ConfigurationRepository
) => new InsertInvoiceRIPSByCompanyIdAdminUseCase(CompanyRepo);
export const InsertInvoiceRIPSByCompanyIdAdminUseCaseProvider = {
  provide: InsertInvoiceRIPSByCompanyIdAdminUseCase,
  useFactory: insertInvoiceRIPSByCompanyIdAdminUseCaseFactory,
  deps: [ConfigurationRepository],
};

const insertInvoiceRIPSConfigurationUseCaseFactory = (
  ConvenioRepo: ConfigurationRepository
) => new InsertInvoiceRIPSConfigurationUseCase(ConvenioRepo);
export const InsertInvoiceRIPSConfigurationUseCaseProvider = {
  provide: InsertInvoiceRIPSConfigurationUseCase,
  useFactory: insertInvoiceRIPSConfigurationUseCaseFactory,
  deps: [ConfigurationRepository],
};

const updateInvoiceRIPSConfigurationUseCaseFactory = (
  ConvenioRepo: ConfigurationRepository
) => new UpdateInvoiceRIPSConfigurationUseCase(ConvenioRepo);
export const UpdateInvoiceRIPSConfigurationUseCaseProvider = {
  provide: UpdateInvoiceRIPSConfigurationUseCase,
  useFactory: updateInvoiceRIPSConfigurationUseCaseFactory,
  deps: [ConfigurationRepository],
};

const updateInvoiceRIPSByCompanyIdAdminUseCaseFactory = (
  CompanyRepo: ConfigurationRepository
) => new UpdateInvoiceRIPSByCompanyIdAdminUseCase(CompanyRepo);
export const UpdateInvoiceRIPSByCompanyIdAdminUseCaseProvider = {
  provide: UpdateInvoiceRIPSByCompanyIdAdminUseCase,
  useFactory: updateInvoiceRIPSByCompanyIdAdminUseCaseFactory,
  deps: [ConfigurationRepository],
};

/**Headquarters */
const getHeadquarterssUseCaseFactory = (HeadquartersRepo: ConfigurationRepository) =>
  new GetHeadquartersByIdCompanyUseCase(HeadquartersRepo);
export const GetHeadquarterssUseCaseProvider = {
  provide: GetHeadquartersByIdCompanyUseCase,
  useFactory: getHeadquarterssUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getHeadquartersByCompanyidUseCaseFactory = (
  HeadquartersRepo: ConfigurationRepository
) => new GetHeadquartersByCompanyidUseCase(HeadquartersRepo);
export const GetHeadquartersByCompanyidUseCaseProvider = {
  provide: GetHeadquartersByCompanyidUseCase,
  useFactory: getHeadquartersByCompanyidUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getHeadquartersAllByCompanyIdAdminUseCaseFactory = (HeadquartersRepo: ConfigurationRepository) =>
  new GetHeadquartersAllByCompanyIdAdminUseCase(HeadquartersRepo);
export const GetHeadquartersAllByCompanyIdAdminUseCaseProvider = {
  provide: GetHeadquartersAllByCompanyIdAdminUseCase,
  useFactory: getHeadquartersAllByCompanyIdAdminUseCaseFactory,
  deps: [ConfigurationRepository],
};

const insertHeadquarterssUseCaseFactory = (HeadquartersRepo: ConfigurationRepository) =>
  new InsertHeadquartersUseCase(HeadquartersRepo);
export const InsertHeadquarterssUseCaseProvider = {
  provide: InsertHeadquartersUseCase,
  useFactory: insertHeadquarterssUseCaseFactory,
  deps: [ConfigurationRepository],
};

const insertHeadquartersAdminUseCaseFactory = (HeadquartersRepo: ConfigurationRepository) =>
  new InsertHeadquartersAdminUseCase(HeadquartersRepo);
export const InsertHeadquartersAdminUseCaseProvider = {
  provide: InsertHeadquartersAdminUseCase,
  useFactory: insertHeadquartersAdminUseCaseFactory,
  deps: [ConfigurationRepository],
};

const updateHeadquarterssUseCaseFactory = (HeadquartersRepo: ConfigurationRepository) =>
  new UpdateHeadquartersUseCase(HeadquartersRepo);
export const UpdateHeadquartersUseCaseProvider = {
  provide: UpdateHeadquartersUseCase,
  useFactory: updateHeadquarterssUseCaseFactory,
  deps: [ConfigurationRepository],
};

const updateHeadquartersAdminUseCaseFactory = (HeadquartersRepo: ConfigurationRepository) =>
  new UpdateHeadquartersAdminUseCase(HeadquartersRepo);
export const UpdateHeadquartersAdminUseCaseProvider = {
  provide: UpdateHeadquartersAdminUseCase,
  useFactory: updateHeadquartersAdminUseCaseFactory,
  deps: [ConfigurationRepository],
};

const deleteHeadquartersUseCaseFactory = (HeadquartersRepo: ConfigurationRepository) =>
  new DeleteHeadquartersUseCase(HeadquartersRepo);
export const DeleteHeadquartersUseCaseProvider = {
  provide: DeleteHeadquartersUseCase,
  useFactory: deleteHeadquartersUseCaseFactory,
  deps: [ConfigurationRepository],
};

/**Offices */
const getOfficesUseCaseFactory = (OfficesRepo: ConfigurationRepository) =>
  new GetOfficeByHeadquartersUseCase(OfficesRepo);
export const GetOfficessUseCaseProvider = {
  provide: GetOfficeByHeadquartersUseCase,
  useFactory: getOfficesUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getOfficeByHeadquartersIdAdminUseCaseFactory = (
  OfficesRepo: ConfigurationRepository
) => new GetOfficeByHeadquartersIdAdminUseCase(OfficesRepo);
export const GetOfficeByHeadquartersIdAdminUseCaseProvider = {
  provide: GetOfficeByHeadquartersIdAdminUseCase,
  useFactory: getOfficeByHeadquartersIdAdminUseCaseFactory,
  deps: [ConfigurationRepository],
};

const insertOfficessUseCaseFactory = (OfficesRepo: ConfigurationRepository) =>
  new InsertOfficesUseCase(OfficesRepo);
export const InsertOfficessUseCaseProvider = {
  provide: InsertOfficesUseCase,
  useFactory: insertOfficessUseCaseFactory,
  deps: [ConfigurationRepository],
};

const insertOfficesIdAdminUseCaseFactory = (OfficesRepo: ConfigurationRepository) =>
  new InsertOfficesIdAdminUseCase(OfficesRepo);
export const InsertOfficesIdAdminUseCaseProvider = {
  provide: InsertOfficesIdAdminUseCase,
  useFactory: insertOfficesIdAdminUseCaseFactory,
  deps: [ConfigurationRepository],
};

const updateOfficessUseCaseFactory = (OfficesRepo: ConfigurationRepository) =>
  new UpdateOfficesUseCase(OfficesRepo);
export const UpdateOfficesUseCaseProvider = {
  provide: UpdateOfficesUseCase,
  useFactory: updateOfficessUseCaseFactory,
  deps: [ConfigurationRepository],
};

const updateOfficesIdAdminUseCaseFactory = (OfficesRepo: ConfigurationRepository) =>
  new UpdateOfficesIdAdminUseCase(OfficesRepo);
export const UpdateOfficesIdAdminUseCaseProvider = {
  provide: UpdateOfficesIdAdminUseCase,
  useFactory: updateOfficesIdAdminUseCaseFactory,
  deps: [ConfigurationRepository],
};

const deleteOfficesUseCaseFactory = (OfficesRepo: ConfigurationRepository) =>
  new DeleteOfficesUseCase(OfficesRepo);
export const DeleteOfficesUseCaseProvider = {
  provide: DeleteOfficesUseCase,
  useFactory: deleteOfficesUseCaseFactory,
  deps: [ConfigurationRepository],
};

const deleteOfficesIdAdminUseCaseFactory = (OfficesRepo: ConfigurationRepository) =>
  new DeleteOfficesIdAdminUseCase(OfficesRepo);
export const DeleteOfficesIdAdminUseCaseProvider = {
  provide: DeleteOfficesIdAdminUseCase,
  useFactory: deleteOfficesIdAdminUseCaseFactory,
  deps: [ConfigurationRepository],
};

/**Convenio */
const getConveniosUseCaseFactory = (ConvenioRepo: ConfigurationRepository) =>
  new GetConveniosByEmpresaUseCase(ConvenioRepo);
export const GetConveniosUseCaseProvider = {
  provide: GetConveniosByEmpresaUseCase,
  useFactory: getConveniosUseCaseFactory,
  deps: [ConfigurationRepository],
};
const insertConveniosUseCaseFactory = (ConvenioRepo: ConfigurationRepository) =>
  new InsertConvenioUseCase(ConvenioRepo);
export const InsertConvenioUseCaseProvider = {
  provide: InsertConvenioUseCase,
  useFactory: insertConveniosUseCaseFactory,
  deps: [ConfigurationRepository],
};
const updateConveniosUseCaseFactory = (ConvenioRepo: ConfigurationRepository) =>
  new UpdateConvenioUseCase(ConvenioRepo);
export const UpdateConvenioUseCaseProvider = {
  provide: UpdateConvenioUseCase,
  useFactory: updateConveniosUseCaseFactory,
  deps: [ConfigurationRepository],
};
const deleteConveniosUseCaseFactory = (ConvenioRepo: ConfigurationRepository) =>
  new DeleteConvenioUseCase(ConvenioRepo);
export const DeleteConvenioUseCaseProvider = {
  provide: DeleteConvenioUseCase,
  useFactory: deleteConveniosUseCaseFactory,
  deps: [ConfigurationRepository],
};

/** Company */

const getCampusCompanyUseCaseFactory = (CompanyRepo: ConfigurationRepository) =>
  new GetCampusCompanyUseCase(CompanyRepo);
export const GetCampusCompanyUseCaseProvider = {
  provide: GetCampusCompanyUseCase,
  useFactory: getCampusCompanyUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getConsultancyCompanyUseCaseFactory = (
  CompanyRepo: ConfigurationRepository
) => new GetConsultancyCompanyUseCase(CompanyRepo);
export const GetConsultancyCompanyUseCaseProvider = {
  provide: GetConsultancyCompanyUseCase,
  useFactory: getConsultancyCompanyUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getTypeServiceCompanyUseCaseFactory = (
  CompanyRepo: ConfigurationRepository
) => new GetTypeServiceCompanyUseCase(CompanyRepo);
export const GetTypeServiceCompanyUseCaseProvider = {
  provide: GetTypeServiceCompanyUseCase,
  useFactory: getTypeServiceCompanyUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getServiceUseCaseFactory = (ServiceRepo: ConfigurationRepository) =>
  new GetServiceUseCase(ServiceRepo);
export const GetServiceUseCaseProvider = {
  provide: GetServiceUseCase,
  useFactory: getServiceUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getServiceByCompanyidUseCaseFactory = (
  configurationRepo: ConfigurationRepository
) => new GetServiceByCompanyidUseCase(configurationRepo);
export const GetServiceByCompanyidUseCaseProvider = {
  provide: GetServiceByCompanyidUseCase,
  useFactory: getServiceByCompanyidUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getServiceCompanyUseCaseFactory = (
  CompanyRepo: ConfigurationRepository
) => new GetServiceCompanyUseCase(CompanyRepo);
export const GetServiceCompanyUseCaseProvider = {
  provide: GetServiceCompanyUseCase,
  useFactory: getServiceCompanyUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getCollaboratorCompanyUseCaseFactory = (
  CompanyRepo: ConfigurationRepository
) => new GetCollaboratorCompanyUseCase(CompanyRepo);
export const GetCollaboratorCompanyUseCaseProvider = {
  provide: GetCollaboratorCompanyUseCase,
  useFactory: getCollaboratorCompanyUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getProfesionalByCompanyidUseCaseFactory = (
  CompanyRepo: ConfigurationRepository
) => new GetProfesionalByCompanyidUseCase(CompanyRepo);
export const GetProfesionalByCompanyidUseCaseProvider = {
  provide: GetProfesionalByCompanyidUseCase,
  useFactory: getProfesionalByCompanyidUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getCollaboratorCompanyAllUseCaseFactory = (
  CompanyRepo: ConfigurationRepository
) => new GetCollaboratorCompanyAllUseCase(CompanyRepo);
export const GetCollaboratorCompanyAllUseCaseProvider = {
  provide: GetCollaboratorCompanyAllUseCase,
  useFactory: getCollaboratorCompanyAllUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getCollaboratorAllAdminUseCaseFactory = (
  CompanyRepo: ConfigurationRepository
) => new GetCollaboratorAllAdminUseCase(CompanyRepo);
export const GetCollaboratorAllAdminUseCaseProvider = {
  provide: GetCollaboratorAllAdminUseCase,
  useFactory: getCollaboratorAllAdminUseCaseFactory,
  deps: [ConfigurationRepository],
};


const getStateCollaboratorUseCaseFactory = (CompanyRepo: ConfigurationRepository) =>
  new GetStateCollaboratorUseCase(CompanyRepo);
export const GetStateCollaboratorUseCaseProvider = {
  provide: GetStateCollaboratorUseCase,
  useFactory: getStateCollaboratorUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getPlanBusinessUseCaseFactory = (CompanyRepo: ConfigurationRepository
) => new GetPlanBusinessUseCase(CompanyRepo);
export const GetPlanBusinessUseCaseProvider = {
  provide: GetPlanBusinessUseCase,
  useFactory: getPlanBusinessUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getPlanBussinesIdAdminUseCaseFactory = (CompanyRepo: ConfigurationRepository) =>
  new GetPlanBussinesIdAdminUseCase(CompanyRepo);
export const GetPlanBussinesIdAdminUseCaseProvider = {
  provide: GetPlanBussinesIdAdminUseCase,
  useFactory: getPlanBussinesIdAdminUseCaseFactory,
  deps: [ConfigurationRepository],
};

const insertCollaboratorUseCaseFactory = (CompanyRepo: ConfigurationRepository) =>
  new InsertCollaboratorUseCase(CompanyRepo);
export const InsertCollaboratorUseCaseProvider = {
  provide: InsertCollaboratorUseCase,
  useFactory: insertCollaboratorUseCaseFactory,
  deps: [ConfigurationRepository],
};

const insertCollaboratorAllAdminUseCaseFactory = (CompanyRepo: ConfigurationRepository) =>
  new InsertCollaboratorAllAdminUseCase(CompanyRepo);
export const InsertCollaboratorAllAdminUseCaseProvider = {
  provide: InsertCollaboratorAllAdminUseCase,
  useFactory: insertCollaboratorAllAdminUseCaseFactory,
  deps: [ConfigurationRepository],
};

const updateCollaboratorUseCaseFactory = (CompanyRepo: ConfigurationRepository) =>
  new UpdateCollaboratorUseCase(CompanyRepo);
export const UpdateCollaboratorUseCaseProvider = {
  provide: UpdateCollaboratorUseCase,
  useFactory: updateCollaboratorUseCaseFactory,
  deps: [ConfigurationRepository],
};

const updateCollaboratorAllAdminUseCaseFactory = (CompanyRepo: ConfigurationRepository) =>
  new UpdateCollaboratorAllAdminUseCase(CompanyRepo);
export const UpdateCollaboratorAllAdminUseCaseProvider = {
  provide: UpdateCollaboratorAllAdminUseCase,
  useFactory: updateCollaboratorAllAdminUseCaseFactory,
  deps: [ConfigurationRepository],
};



//**Terceros */
const getThirdCompanyByIdUseCaseFactory = (
  ThirdCompanyRepo: ConfigurationRepository
) => new GetThirdCompanyByIdUseCase(ThirdCompanyRepo);
export const GetThirdCompanyByIdUseCaseProvider = {
  provide: GetThirdCompanyByIdUseCase,
  useFactory: getThirdCompanyByIdUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getThirdCompanyUseCaseFactory = (
  ThirdCompanyRepo: ConfigurationRepository
) => new GetThirdCompanyUseCase(ThirdCompanyRepo);
export const GetThirdCompanyUseCaseProvider = {
  provide: GetThirdCompanyUseCase,
  useFactory: getThirdCompanyUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getThirdCompanyAllUseCaseFactory = (
  ThirdCompanyRepo: ConfigurationRepository
) => new GetThirdCompanyAllUseCase(ThirdCompanyRepo);
export const GetThirdCompanyAllUseCaseProvider = {
  provide: GetThirdCompanyAllUseCase,
  useFactory: getThirdCompanyAllUseCaseFactory,
  deps: [ConfigurationRepository],
};

const insertThirdCompanyUseCaseFactory = (
  ThirdCompanyRepo: ConfigurationRepository
) => new InsertThirdCompanyUseCase(ThirdCompanyRepo);
export const InsertThirdCompanyUseCaseProvider = {
  provide: InsertThirdCompanyUseCase,
  useFactory: insertThirdCompanyUseCaseFactory,
  deps: [ConfigurationRepository],
};

const deleteThirdCompanyUseCaseFactory = (
  ThirdCompanyRepo: ConfigurationRepository
) => new DeleteThirdCompanyUseCase(ThirdCompanyRepo);
export const DeleteThirdCompanyUseCaseProvider = {
  provide: DeleteThirdCompanyUseCase,
  useFactory: deleteThirdCompanyUseCaseFactory,
  deps: [ConfigurationRepository],
};

const updateThirdCompanyUseCaseFactory = (
  ThirdCompanyRepo: ConfigurationRepository
) => new UpdateThirdCompanyUseCase(ThirdCompanyRepo);
export const UpdateThirdCompanyUseCaseProvider = {
  provide: UpdateThirdCompanyUseCase,
  useFactory: updateThirdCompanyUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getStateCivilUseCaseFactory = (stateCivil: ConfigurationRepository) =>
  new GetStateCivilUseCase(stateCivil);
export const GetStateCivilUseCaseProvider = {
  provide: GetStateCivilUseCase,
  useFactory: getStateCivilUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getEPSUseCaseFactory = (eps: ConfigurationRepository) =>
  new GetEPSUseCase(eps);
export const GetEPSUseCaseProvider = {
  provide: GetEPSUseCase,
  useFactory: getEPSUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getGenderUseCaseFactory = (gender: ConfigurationRepository) =>
  new GetGenderUseCase(gender);
export const GetGenderUseCaseProvider = {
  provide: GetGenderUseCase,
  useFactory: getGenderUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getRelationShipUseCaseFactory = (relation: ConfigurationRepository) =>
  new GetRelationShipUseCase(relation);
export const GetRelationShipUseCaseProvider = {
  provide: GetRelationShipUseCase,
  useFactory: getRelationShipUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getDiagnosticUseCaseFactory = (relation: ConfigurationRepository) =>
  new GetDiagnosticUseCase(relation);
export const GetDiagnosticUseCaseProvider = {
  provide: GetDiagnosticUseCase,
  useFactory: getDiagnosticUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getTypeInvoicepUseCaseFactory = (typeInvoice: ConfigurationRepository) =>
  new GetTypeInvoiceUseCase(typeInvoice);
export const GetTypeInvoiceUseCaseProvider = {
  provide: GetTypeInvoiceUseCase,
  useFactory: getTypeInvoicepUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getInvoiceUseCaseFactory = (invoice: ConfigurationRepository) =>
  new GetInvoiceUseCase(invoice);
export const GetInvoiceUseCaseProvider = {
  provide: GetInvoiceUseCase,
  useFactory: getInvoiceUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getProfessionalUseCaseFactory = (professional: ConfigurationRepository) =>
  new GetProfessionalUseCase(professional);
export const GetProfessionalUseCaseProvider = {
  provide: GetProfessionalUseCase,
  useFactory: getProfessionalUseCaseFactory,
  deps: [ConfigurationRepository],
};

const insertInvoiceUseCaseFactory = (invoice: ConfigurationRepository) =>
  new InsertInvoiceUseCase(invoice);
export const InsertInvoiceUseCaseProvider = {
  provide: InsertInvoiceUseCase,
  useFactory: insertInvoiceUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getInvoiceByDateUseCaseFactory = (invoice: ConfigurationRepository) =>
  new GetPendingInvoiceReportUseCase(invoice);
export const GetPendingInvoiceReportUseCaseProvider = {
  provide: GetPendingInvoiceReportUseCase,
  useFactory: getInvoiceByDateUseCaseFactory,
  deps: [ConfigurationRepository],
};

/**Consent */
const getConsentUseCaseFactory = (ConsentRepo: ConfigurationRepository) =>
  new GetConsentUseCase(ConsentRepo);
export const GetConsentUseCaseProvider = {
  provide: GetConsentUseCase,
  useFactory: getConsentUseCaseFactory,
  deps: [ConfigurationRepository],
};

const insertConsentUseCaseFactory = (ConsentRepo: ConfigurationRepository) =>
  new InsertConsentUseCase(ConsentRepo);
export const InsertConsentUseCaseProvider = {
  provide: InsertConsentUseCase,
  useFactory: insertConsentUseCaseFactory,
  deps: [ConfigurationRepository],
};

const deleteConsentUseCaseFactory = (ConsentRepo: ConfigurationRepository) =>
  new DeleteConsentUseCase(ConsentRepo);
export const DeleteConsentUseCaseProvider = {
  provide: DeleteConsentUseCase,
  useFactory: deleteConsentUseCaseFactory,
  deps: [ConfigurationRepository],
};

const updateConsentUseCaseFactory = (ConsentRepo: ConfigurationRepository) =>
  new UpdateConsentUseCase(ConsentRepo);
export const UpdateConsentUseCaseProvider = {
  provide: UpdateConsentUseCase,
  useFactory: updateConsentUseCaseFactory,
  deps: [ConfigurationRepository],
};

/**Business */

const getTypeBusinessUseCaseFactory = (Repo: ConfigurationRepository) =>
  new GetTypeBusinessUseCase(Repo);
export const GetTypeBusinessUseCaseProvider = {
  provide: GetTypeBusinessUseCase,
  useFactory: getTypeBusinessUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getBusinessAllUseCaseFactory = (Repo: ConfigurationRepository) =>
  new GetBusinessAllUseCase(Repo);
export const GetBusinessAllUseCaseProvider = {
  provide: GetBusinessAllUseCase,
  useFactory: getBusinessAllUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getBusinessByIdUseCaseFactory = (Repo: ConfigurationRepository) =>
  new GetBusinessByIdUseCase(Repo);
export const GetBusinessByIdUseCaseProvider = {
  provide: GetBusinessByIdUseCase,
  useFactory: getBusinessByIdUseCaseFactory,
  deps: [ConfigurationRepository],
};

const insertBusinessUseCaseFactory = (Repo: ConfigurationRepository) =>
  new InsertBusinessUseCase(Repo);
export const InsertBusinessUseCaseProvider = {
  provide: InsertBusinessUseCase,
  useFactory: insertBusinessUseCaseFactory,
  deps: [ConfigurationRepository],
};

const updateBusinessUseCaseFactory = (Repo: ConfigurationRepository) =>
  new UpdateBusinessUseCase(Repo);
export const UpdateBusinessUseCaseProvider = {
  provide: UpdateBusinessUseCase,
  useFactory: updateBusinessUseCaseFactory,
  deps: [ConfigurationRepository],
};

const insertDemoBusinessUseCaseFactory = (Repo: ConfigurationRepository) =>
  new InsertDemoBusinessUseCase(Repo);
export const InsertDemoBusinessUseCaseProvider = {
  provide: InsertDemoBusinessUseCase,
  useFactory: insertDemoBusinessUseCaseFactory,
  deps: [ConfigurationRepository],
};

const updateLogoBusinessUseCaseFactory = (Repo: ConfigurationRepository) =>
  new UpdateLogoBusinessUseCase(Repo);
export const UpdateLogoBusinessUseCaseProvider = {
  provide: UpdateLogoBusinessUseCase,
  useFactory: updateLogoBusinessUseCaseFactory,
  deps: [ConfigurationRepository],
};

const updateCollaboratorPositionUseCaseFactory = (Repo: ConfigurationRepository) =>
  new UpdateCollaboratorPositionUseCase(Repo);
export const UpdateCollaboratorPositionUseCaseProvider = {
  provide: UpdateCollaboratorPositionUseCase,
  useFactory: updateCollaboratorPositionUseCaseFactory,
  deps: [ConfigurationRepository],
};

const insertCollaboratorPositionUseCaseFactory = (Repo: ConfigurationRepository) =>
  new InsertCollaboratorPositionUseCase(Repo);
export const InsertCollaboratorPositionUseCaseProvider = {
  provide: InsertCollaboratorPositionUseCase,
  useFactory: insertCollaboratorPositionUseCaseFactory,
  deps: [ConfigurationRepository],
};
const GetCollaboratorPositionUseCaseFactory = (Repo: ConfigurationRepository) =>
  new GetCollaboratorPositionUseCase(Repo);
export const GetCollaboratorPositionUseCaseProvider = {
  provide: GetCollaboratorPositionUseCase,
  useFactory: GetCollaboratorPositionUseCaseFactory,
  deps: [ConfigurationRepository],
};

const getDocumentsSystemUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new GetDocumentsSystemUseCase(
    ClientRepo
);

export const
GetDocumentsSystemUseCaseProvider = {
    provide:
    GetDocumentsSystemUseCase,
    useFactory:
    getDocumentsSystemUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};

const createdocumentsystemUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new CreateDocumentSystemUseCase(
    ClientRepo
);

export const
CreateDocumentSystemUseCaseProvider = {
    provide:
    CreateDocumentSystemUseCase,
    useFactory:
    createdocumentsystemUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};

const updatedocumentssystemUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new UpdateDocumentsSystemUseCase(
    ClientRepo
);

export const
UpdateDocumentsSystemUseCaseProvider = {
    provide:
    UpdateDocumentsSystemUseCase,
    useFactory:
    updatedocumentssystemUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};

const getFileDocumentsSystemUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new GetFileDocumentsSystemUseCase(
    ClientRepo
);

export const
GetFileDocumentsSystemUseCaseProvider = {
    provide:
    GetFileDocumentsSystemUseCase,
    useFactory:
    getFileDocumentsSystemUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};

const createfiledocumentssystemUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new CreateFileDocumentsSystemUseCase(
    ClientRepo
);

export const
CreateFileDocumentsSystemUseCaseProvider = {
    provide:
    CreateFileDocumentsSystemUseCase,
    useFactory:
    createfiledocumentssystemUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};


const updatefiledocumentssystemUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new UpdateFileDocumentsSystemUseCase(
    ClientRepo
);

export const
UpdateFileDocumentsSystemUseCaseProvider = {
    provide:
    UpdateFileDocumentsSystemUseCase,
    useFactory:
    updatefiledocumentssystemUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};

const getChannelSendUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new GetChannelSendUseCase(
    ClientRepo
);

export const
GetChannelSendUseCaseProvider = {
    provide:
    GetChannelSendUseCase,
    useFactory:
    getChannelSendUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};


const createchannelsendUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new CreateChannelSendUseCase(
    ClientRepo
);

export const
CreateChannelSendUseCaseProvider = {
    provide:
    CreateChannelSendUseCase,
    useFactory:
    createchannelsendUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};


const updatechannelsendUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new UpdateChannelSendUseCase(
    ClientRepo
);

export const
UpdateChannelSendUseCaseProvider = {
    provide:
    UpdateChannelSendUseCase,
    useFactory:
    updatechannelsendUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};

const getFileDocumentsSystemByIdUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new GetFileDocumentsSystemByIdUseCase(
    ClientRepo
);

export const
GetFileDocumentsSystemByIdUseCaseProvider = {
    provide:
    GetFileDocumentsSystemByIdUseCase,
    useFactory:
    getFileDocumentsSystemByIdUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};



const getAllMenuUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new GetAllMenuUseCase(
    ClientRepo
);

export const
GetAllMenuUseCaseProvider = {
    provide:
    GetAllMenuUseCase,
    useFactory:
    getAllMenuUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};


const insertmenuUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new InsertMenuUseCase(
    ClientRepo
);

export const
InsertMenuUseCaseProvider = {
    provide:
    InsertMenuUseCase,
    useFactory:
    insertmenuUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};


const updatemenuUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new UpdateMenuUseCase(
    ClientRepo
);

export const
UpdateMenuUseCaseProvider = {
    provide:
    UpdateMenuUseCase,
    useFactory:
    updatemenuUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};

const getAllPerfilUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new GetAllPerfilUseCase(
    ClientRepo
);

export const
GetAllPerfilUseCaseProvider = {
    provide:
    GetAllPerfilUseCase,
    useFactory:
    getAllPerfilUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};



const insertperfilUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new InsertPerfilUseCase(
    ClientRepo
);

export const
InsertPerfilUseCaseProvider = {
    provide:
    InsertPerfilUseCase,
    useFactory:
    insertperfilUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};



const updateperfilUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new UpdatePerfilUseCase(
    ClientRepo
);

export const
UpdatePerfilUseCaseProvider = {
    provide:
    UpdatePerfilUseCase,
    useFactory:
    updateperfilUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};

const getAllPerfilMenuUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new GetAllPerfilMenuUseCase(
    ClientRepo
);

export const
GetAllPerfilMenuUseCaseProvider = {
    provide:
    GetAllPerfilMenuUseCase,
    useFactory:
    getAllPerfilMenuUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};


const insertperfilmenuUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new InsertPerfilMenuUseCase(
    ClientRepo
);

export const
InsertPerfilMenuUseCaseProvider = {
    provide:
    InsertPerfilMenuUseCase,
    useFactory:
    insertperfilmenuUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};

const deleteperfilmenuUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new DeletePerfilMenuUseCase(
    ClientRepo
);

export const
DeletePerfilMenuUseCaseProvider = {
    provide:
    DeletePerfilMenuUseCase,
    useFactory:
    deleteperfilmenuUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};


const getallperfilmenubyidUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new GetAllPerfilMenuByIdUseCase(
    ClientRepo
);

export const
GetAllPerfilMenuByIdUseCaseProvider = {
    provide:
    GetAllPerfilMenuByIdUseCase,
    useFactory:
    getallperfilmenubyidUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};

const getbusinessbypagedUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new GetBusinessByPagedUseCase(
    ClientRepo
);

export const
GetBusinessByPagedUseCaseProvider = {
    provide:
    GetBusinessByPagedUseCase,
    useFactory:
    getbusinessbypagedUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};


const getbusinessbyidadminUseCaseFactory =
(ClientRepo: ConfigurationRepository) =>
new GetBusinessByIdAdminUseCase(
    ClientRepo
);

export const
GetBusinessByIdAdminUseCaseProvider = {
    provide:
    GetBusinessByIdAdminUseCase,
    useFactory:
    getbusinessbyidadminUseCaseFactory,
    deps: [
        ConfigurationRepository
    ],
};
